import PropTypes from 'prop-types';
import { Component } from 'react';

import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import loadScript from 'hb-react/shared/utils/loadScript';

class LegacyPaymentForm extends Component {
  componentDidMount() {
    this.launchStripe();
  }

  componentWillUnmount() {
    this.handler.close();
  }

  handlePaymentSuccess = (request) => {
    const { onPaymentSuccess } = this.props;

    if (onPaymentSuccess) onPaymentSuccess(request.data);
  };

  handlePaymentError = (request) => {
    const { onPaymentError } = this.props;
    let error;

    if (onPaymentError) {
      onPaymentError(request);
    } else {
      if (request?.response?.data?.errors) {
        error = request.response.data.errors;
      } else if (request.message) {
        error = request.message;
      }

      displayNotif('error', error);
    }
  };

  handlePaymentCancel = () => {
    const { onPaymentCancel } = this.props;

    if (onPaymentCancel) {
      onPaymentCancel();
    }
  };

  handleToken = (token) => {
    const { endpointUrl, endpointData } = this.props;

    axios
      .post(endpointUrl, {
        ...endpointData,
        transaction_token: token.id,
        gateway: 'Stripe',
      })
      .then(this.handlePaymentSuccess)
      .catch(this.handlePaymentError);
  };

  launchStripe = async () => {
    const { amount, title, image, userEmail } = this.props;

    // Lazy load stripe v2 dependencies if it's not already loaded
    if (!window.StripeCheckout) {
      await Promise.all([
        loadScript('https://js.stripe.com/v2/'),
        loadScript('https://checkout.stripe.com/checkout.js'),
      ]);
    }

    this.handler = window.StripeCheckout.configure({
      key: window.__HB_ENV__.STRIPE_PUBLISHABLE_KEY,
      email: userEmail,
      image,
      token: this.handleToken,
      closed: this.handlePaymentCancel,
    });

    this.handler.open({
      name: title,
      currency: this.currencyCode(),
      amount,
    });
  };

  currencyCode() {
    const { currency } = this.props;

    return typeof currency === 'string' ? currency : currency.code;
  }

  render() {
    return null;
  }
}

LegacyPaymentForm.propTypes = {
  title: PropTypes.string.isRequired,
  userEmail: PropTypes.string,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  endpointUrl: PropTypes.string.isRequired,
  endpointData: PropTypes.object,
  image: PropTypes.string,
  onPaymentSuccess: PropTypes.func,
  onPaymentError: PropTypes.func,
  onPaymentCancel: PropTypes.func,
};

export default LegacyPaymentForm;
